export const tell_errors = {};

export const tellalidate = (id, value, constraints, allInputs = {}) => {
  let validation_res = true;
  if (!constraints[id]) {
    return validation_res;
  }

  if(constraints[id].must_match){

    // check if it matches 
  
    if(value!==allInputs[constraints[id].must_match.match_item]){
      validation_res = false;
    tell_errors[id] =
      constraints[id].name + " " + constraints[id].must_match.message;
    return validation_res;
    }
  }

  if (!checkPresence(constraints[id].presence, value)) {
    validation_res = false;
    tell_errors[id] = constraints[id].name + " is a mandatory input";
    return validation_res;
  }
  if (!checkLength(constraints[id].length, value)) {
    validation_res = false;
    tell_errors[id] =
      constraints[id].name + " " + constraints[id].length.message;
    return validation_res;
  }

  if (tell_errors[id]) {
    delete tell_errors[id];
  }
  return validation_res;
};

export const tellidate_form = (allStoredInputs, constraints) => {
  // Loop through constraints
  var validate_rsp = true;

  for (const constraint in constraints) {
    
    if (!allStoredInputs[constraint]) {
      tell_errors[constraint] =
        constraints[constraint].name + " is a mandatory input";
      validate_rsp = false;
    } else {
      if (
        !checkPresence(
          constraints[constraint].presence,
          allStoredInputs[constraint]
        )
      ) {
        validate_rsp = false;
        tell_errors[constraint] =
          constraints[constraint].name + " is a mandatory input";
      }
      if (
        !checkLength(
          constraints[constraint].length,
          allStoredInputs[constraint]
        )
      ) {
        validate_rsp = false;
        tell_errors[constraint] =
          constraints[constraint].name +
          " " +
          constraints[constraint].length.message;
      }
    }
  }

  return validate_rsp;
};

const checkPresence = (presence, value) => {
  if (!presence) {
    return true;
  } else {
    return value.length > 0 ? true : false;
  }
};

const checkLength = (length_obj, value) => {
  if (length_obj.min) {
    if (value.length < length_obj.min) {
      return false;
    }
  }

  if (length_obj.max) {
    if (value.length > length_obj.max) {
      return false;
    }
  }
  return true;
};
